import React, { FC } from 'react'

import CircularProgress from '@pixel/core/CircularProgress'
import { styled } from '@pixel/core/styles'

const FloatingCircularProgressContainer = styled('div')({
    height: '100%',
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    overflow: 'hidden',
    zIndex: 100,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
})

interface FloatingCircularProgressProps {
    open: boolean
}

const FloatingCircularProgress: FC<FloatingCircularProgressProps> = ({
    open,
}) => {
    if (!open) return null

    return (
        <FloatingCircularProgressContainer>
            <CircularProgress size={34} />
        </FloatingCircularProgressContainer>
    )
}

export default FloatingCircularProgress
